module.exports = __webpack_public_path__ + "static/media/Screen 5_Documents.3188e963.png";